import { CustomFlowbiteTheme } from "flowbite-react";

const lightTheme: CustomFlowbiteTheme = {
    button: {
      color: {
        primary: "bg-blue-500 hover:bg-blue-600 text-white",
        secondary: "bg-gray-500 hover:bg-gray-600",
        navbarLink: ""
      },
    },
};

export default lightTheme;